// extracted by mini-css-extract-plugin
module.exports = {"formToggleWrap":"FormToggle_formToggleWrap__390uJ","tab":"FormToggle_tab__15gOP","activeOverlay":"FormToggle_activeOverlay__4TPt6","activeText":"FormToggle_activeText__2Q1vk"};